export default __webpack_public_path__ + "static/media/Xbox.b108a207.svg";